import { useState, ReactNode } from "react";
import { IconType } from 'react-icons';
import { useTranslation } from 'react-i18next';

interface PointProps {
    icon: IconType,
    title: string,
    description: string,
}

const formatTextWithItalics = (text: string): ReactNode => {
    // Check if text contains backticks
    if (!text.includes('`')) return text;
    
    // Split the text by backticks
    const parts = text.split('`');
    const result: ReactNode[] = [];
    
    // Alternate between normal and italic text
    parts.forEach((part, index) => {
        if (index % 2 === 0) {
            // Even indices are regular text
            result.push(part);
        } else {
            // Odd indices should be italic
            result.push(<i key={index}>{part}</i>);
        }
    });
    
    return result;
};

const Point = ({title, description, icon: Icon}: PointProps) => {
    const [isFlipped, setIsFlipped] = useState(false);
    const { t } = useTranslation();

    return (
        <div 
            className="flex flex-col items-center cursor-pointer"
            onClick={() => setIsFlipped(!isFlipped)}
        >
            <div className="relative w-[280px] h-[280px] md:w-[300px] md:h-[300px] [perspective:1000px]">
                <div className={`w-full h-full transition-all duration-500 [transform-style:preserve-3d] ${isFlipped ? '[transform:rotateY(180deg)]' : ''}`}>
                    {/* Front of card */}
                    <div className="absolute w-full h-full bg-primary-blue rounded-full flex flex-col items-center justify-center text-white p-8 [backface-visibility:hidden]">
                        <div className="text-5xl mb-4">
                            <Icon />
                        </div>
                        <h4 className="text-2xl font-bold text-center mb-4">{formatTextWithItalics(title)}</h4>
                        <p className="text-center text-[10px] md:text-xs mt-2 text-white/60 italic">
                            {t('common.click')}
                        </p>
                    </div>
                    
                    {/* Back of card */}
                    <div className="absolute w-full h-full bg-primary-blue rounded-full flex items-center justify-center text-white p-8 [backface-visibility:hidden] [transform:rotateY(180deg)]">
                        <p className="text-center text-sm md:text-base">{formatTextWithItalics(description)}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Point